<axis-contact-hero-banner
  displayType="form"
  [contactDetails]="contactDetails"
  [contactInfoSections]="contactInfoSections"
  id="contact-form"
></axis-contact-hero-banner>

<axis-cards
  [headerTitle]="'Get in Touch'"
  [headerSubtitle]="'We’re here to answer your questions'"
  [cards]="cards"
>
</axis-cards>

<axis-faq
  [faqImageUrl]="'/images/faq.png'"
  [faqImageAlt]="'Custom FAQ Image'"
  [faqItems]="faqItem"
></axis-faq>
